import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addUpdateFolderRes;
export const addUpdateFolderTodo = createAsyncThunk('addUpdateFolder', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'library/add_update_folder',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "folder_name": data.folder_name,
                "size": "",
                "description": data.folder_desc,
                "created_by": user_id.vemp_code,
                "device_token": user_id.vdevice_token
            },
             headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addUpdateFolderRes = res.data
    } catch (error) {
        return addUpdateFolderRes = error.response.data
    }
})